import {
  CloseOutline,
  DashboardOutline,
  EyeInvisibleOutline,
  FormOutline,
  InfoCircleFill,
  Loading3QuartersOutline,
  LoadingOutline,
  MenuFoldOutline,
  MenuUnfoldOutline,
  MoreOutline,
} from '@ant-design/icons-angular/icons';

export const icons = [
  MenuFoldOutline,
  MenuUnfoldOutline,
  DashboardOutline,
  FormOutline,
  MoreOutline,
  EyeInvisibleOutline,
  InfoCircleFill,
  CloseOutline,
  LoadingOutline,
  Loading3QuartersOutline,
];
